import { Drawer, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { trackEditPickupLocationButtonDisplayed } from '../../../utils/edit-pickup-location/analytics';
import { EditPickupLocationDrawer } from './EditPickupLocationDrawer';
export var EditPickupLocation = function (_a) {
    var setShowDrawerError = _a.setShowDrawerError;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(false), isOuterClick = _c[0], setIsOuterClick = _c[1];
    useEffect(function () {
        trackEditPickupLocationButtonDisplayed();
    }, []);
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Link, { component: "button", variant: "body-base", onClick: function () {
                setOpen(true);
            } }, "Edit"),
        open && (React.createElement(Drawer, { open: open, onClose: function () {
                setIsOuterClick(true);
            } },
            React.createElement(EditPickupLocationDrawer, { setOpen: setOpen, setShowDrawerError: setShowDrawerError, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick })))));
};
